<template>
  <div class="h-stack">
    <h6 class="section-label mb-1">
      {{ $t('chat.ticket-history') }}
    </h6>

    <div
      v-b-modal.create-ticket-form
      class="clickable-icon"
    >
      <feather-icon
        icon="PlusIcon"
        size="28"
        class="mr-50"
      />
    </div>

    <b-modal
      id="create-ticket-form"
      size="lg"
      title="Create New Ticket"
      :centered="true"
      :hide-footer="false"
    >
      <b-form @submit.prevent="onSubmit">
        <div class="create-form-container">
          <div class="create-form-ticket">
            <div class="form-group">
              <label for="ticket-title"> ticket.ticket_title </label>
              <b-form-input
                id="ticket-title"
                v-model="formData.title"
                title="Ticket title"
                type="text"
                required
              />
            </div>

            <div class="form-group">
              <label for="assign_to"> ticket.assign_to </label>
              <b-form-select
                id="assign_to"
                v-model="formData.operatorAssigned"
                :options="options.assignOptions"
                type="text"
                required
              />
            </div>

            <div class="form-group">
              <label for="customer_email">ticket.customer_email</label>
              <b-form-input
                id="customer_email"
                v-model="formData.customerEmail"
                type="email"
                required
              />
            </div>

            <div class="form-group">
              <label for="priority">ticket.priority</label>
              <b-form-select
                id="priority"
                v-model.number="formData.priorityLevel"
                :options="options.priorityOptions"
                type="number"
                required
              />
            </div>
          </div>
          <div class="form-group">
            <label for="ticket_title">ticket.description</label>
            <b-form-textarea
              id="ticket_title"
              v-model="formData.ticketDescription"
              placeholder="Enter something..."
              rows="3"
              max-rows="6"
              type="text"
              required
            />
          </div>
          <CSwitch @checked="HandleSwitch" />
        </div>
        <div
          class="mt-1"
          style="text-align: end"
        >
          <b-button
            type="submit"
            variant="primary"
          >
            Submit
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import CSwitch from '@/components/chat-input-components/CSwitch.vue'
import {
  BForm,
  BButton,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BModal,
} from 'bootstrap-vue'
// import Repository from '@/repositories/RepositoryFactory'

import TicketRepository from '@/repositories/Api/TicketRepository'

export default {
  name: 'CreateTicketForm',
  components: {
    CSwitch,
    BButton,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BModal,
    BForm,
  },
  props: {
    activeChannel: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      displayData: {
        ticketList: [],
      },
      formData: {
        title: '',
        customerEmail: '',
        operatorAssigned: '639c41b5168d5d001e4926fe',
        ticketDescription: '',
        priorityLevel: '', // unassigned: 0, 1: low, 2: high, 3: medium, 4: urgent
        internalNote: 1, // 0: on, 1: off
        customerId: '',
      },
      options: {
        assignSelected: '',
        assignOptions: [],
        prioritySelected: '',
        priorityOptions: [],
      },
    }
  },
  watch: {
    activeChannel(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.ResetInput()
        this.formData.customerId = newVal.customer?.id
        this.formData.customerEmail = newVal.customer?.email || ''
      }
    },
  },
  created() {
    this.GetPriorityOptions()
    this.GetAssignOptions()
  },

  /**
   * Status Description 🦀
   * operatorAssigned = unassigned: 0, 1: low, 2: high, 3: medium, 4: urgent
   */
  methods: {
    onSubmit() {
      TicketRepository.CreateTicket(this.formData)
        .then(res => {
          this.$bvModal.hide('create-ticket-form')
          this.ResetInput()
          console.log(res.data)
        })
        .catch(error => {
          console.log(error)
          this.ResetInput()
        })
    },
    GetTicketList() {
      TicketRepository.GetTicketList()
        .then(response => {
          console.log(response.data.data)
        })
        .catch(e => console.log(e))
    },
    GetPriorityOptions() {
      TicketRepository.GetPriorityOptions()

        .then(response => {
          const responsesData = response.data.data

          const options = []
          Object.entries(responsesData).map(item => {
            options.push({
              text: item[0].toUpperCase(),
              value: item[1],
            })
          })
          this.options.priorityOptions = options
        })
        .catch(e => console.log(e))
    },
    GetAssignOptions() {
      TicketRepository.GetAssignOptions()
        .then(response => {
          const responsesData = response.data.data
          console.log(responsesData)

          this.options.assignOptions = responsesData.map(item => ({
            text: `${item.firstName} ${item.lastName}`,
            value: item.id,
          }))
        })
        .catch(e => console.log(e))
    },
    CreateTicket() {
      TicketRepository.CreateTicket()
    },
    UpdateTicket() {
      TicketRepository.UpdateTicket()
    },
    HandleSwitch(emitValue) {
      // 0: off, 1: on

      this.formData.internalNote = emitValue ? 1 : 0
    },
    ResetInput() {
      this.formData = {
        title: '',
        customerEmail: '',
        operatorAssigned: '',
        ticketDescription: '',
        priorityLevel: '',
        internalNote: 1,
        customerId: '',
      }
    },
  },
}
</script>
